import React from 'react';
import { Controller } from 'react-hook-form';
import { Form, Dropdown } from 'semantic-ui-react';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

const ContactGroupForm = ({control, group, isSubgroup}) => {
    const SHARED_DROPDOWN = [
        { key: 'personal', value: 'personal', text: 'Personal', userPermission: USER_PERMISSIONS.GROUPS_SUBGROUPS_ADD},
        { key: 'company', value: 'company', text: 'Company', userPermission: USER_PERMISSIONS.GROUPS_SUBGROUPS_ADD},
    ]

    return (
        <Form>
            <Form.Group>
                <Controller 
                    name={"name"}
                    control={control}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Form.Input
                            onChange={onChange}
                            value={value}
                            label={isSubgroup ? 'Subgroup Name' : 'Group Name'}
                            error={error && error.message}
                            placeholder="Enter Name"
                            required
                        />
                    )}
                />
                {!isSubgroup && (
                    <Controller
                        name={"shared_type"}
                        control={control}
                        render={({ field: { name, onChange, value } }) => (
                            <Form.Select
                                className='GroupForm__sharedSelect'
                                disabled={group}
                                name={name}
                                value={value}
                                text={SHARED_DROPDOWN.find(item => item.value === value)?.text}
                                label='Shared Type'
                                placeholder='Select Type'
                                required
                            >
                                <Dropdown.Menu>
                                    {SHARED_DROPDOWN.map(item => (
                                        <RestrictedView type="disabled" userPermission={item.userPermission} userRestrict modifiers={item.value}>
                                            <Dropdown.Item key={item.key} value={item.value} text={item.text} active={value === item.value} selected={value === item.value} onClick={() => {
                                                onChange(item.value)
                                            }} />
                                        </RestrictedView>
                                    ))}
                                </Dropdown.Menu>
                            </Form.Select>
                        )}
                    />
                )}
            </Form.Group>
        </Form>
    ); 
}

export default ContactGroupForm;